import React from "react";
import "./MenuLogin.scss";

const MenuLogin = () => {
  return (
    <div className="contendorMenuTopLogin">
      <div className="imgLogo"></div>
      <div className="menu-top">
        {/* <div>About</div>
        <div>Pricing</div>
        <div>Products</div>
        <div>Contact</div> */}
      </div>
    </div>
  );
};

export default MenuLogin;
